import React from "react";
import { ContentRecord } from "models/view-models/contents/content-record";
import { FileRecord } from "models/view-models/files/file-record";
import { FormFileInput } from "components/form/form-file-input/form-file-input";
import { FormTextArea } from "components/form/form-textarea/form-textarea";
import { FormTextInput } from "components/form/form-input/form-text-input";
import { InputTypes } from "components/form/enumerations/input-types";
import { RecordUtils } from "andculturecode-javascript-core";
import { StorageContainers } from "utilities/files/enumerations/storage-containers";
import { ToastManager } from "utilities/toast/toast-manager";
import { t } from "utilities/localization/t";
import "./course-create-content-form.scss";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface CourseCreateContentFormProps {
    content: ContentRecord;
    onContentChanged: (content: ContentRecord) => void;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// ------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "course-create-content-form";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const CourseCreateContentForm: React.FC<CourseCreateContentFormProps> = (props) => {
    const handleSetFileId = (file: FileRecord) => {
        props.onContentChanged(
            props.content.with({
                file: RecordUtils.ensureRecord(file, FileRecord),
                fileId: file.id,
            })
        );
    };

    const handleInvalidFile = (): void => {
        ToastManager.error(t("theSelectedFileTypeIsNotPermitted"));
    };

    const handleSetName = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onContentChanged(props.content.with({ name: e.target.value }));
    };

    const handleSetDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        props.onContentChanged(props.content.with({ description: e.target.value }));
    };

    return (
        <React.Fragment>
            <div className={CSS_CLASS_NAME}>
                <FormTextInput
                    formFieldName="contentName"
                    id="contentName"
                    label={t("name")}
                    maxLength={60}
                    onChange={handleSetName}
                    placeholder={t("enterContentName")}
                    required={true}
                    type={InputTypes.Text}
                    value={props.content.name}
                />
                <FormTextArea
                    formFieldName="contentDescription"
                    id="contentDescription"
                    label={t("description")}
                    maxLength={1000}
                    onChange={handleSetDescription}
                    placeholder={t("enterContentDescription")}
                    required={true}
                    rows={5}
                    value={props.content.description}
                />
                <FormFileInput
                    buttonText={t("chooseFile")}
                    formFieldName="file"
                    id="file"
                    label={t("fileUpload")}
                    onFileInvalid={handleInvalidFile}
                    onFileUpload={handleSetFileId}
                    placeholder={t("selectFile")}
                    required={true}
                    storageContainer={StorageContainers.FileUpload}
                    value={props.content.fileId}
                />
            </div>
        </React.Fragment>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { CourseCreateContentForm };

// #endregion Exports
